<section
  class="vehicle-form-wrapper"
  [formGroup]="vehicleForm"
  [class.inside-contract]="isInsideContract"
>
  <div [class.card]="!isInsideContract" class="vehicle-form">
    <div>
      <label class="form-label required">Vehicle Type</label>
      <p-dropdown
        [filter]="true"
        [options]="vehicleTypes"
        optionLabel="name"
        placeholder="Select Vehicle Type"
        class="rounded-3"
        formControlName="type"
        (onChange)="handleTypeSelect($event)"
      ></p-dropdown>
      <ng-container
        *ngTemplateOutlet="formErrors; context: { control: 'type' }"
      ></ng-container>
    </div>

    <div>
      <label class="form-label required">VIN / HIN / RVS / ... NUMBER</label>
      <div class="form-row">
        <input
          type="text"
          maxlength="17"
          class="form-control"
          formControlName="vin"
        />
        <button
          [disabled]="false"
          type="button"
          (click)="validateVin()"
          class="custom-btn validate"
        >
          Validate
          <i *ngIf="false" class="fa-spin fas fa-spinner ms-2"></i>
        </button>
      </div>
      <ng-container
        *ngTemplateOutlet="formErrors; context: { control: 'vin' }"
      ></ng-container>
    </div>

    <div class="vin-status-container">
      <span class="title me-4">VIN Status:</span>
      <div class="form-check me-4">
        <input
          type="radio"
          id="draft"
          [disabled]="true"
          [checked]="!isVINNumberValid"
        />
        <label class="m-0" for="draft"> Not Validated </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="validated"
          [disabled]="true"
          [checked]="isVINNumberValid"
        />
        <label class="m-0" for="validated"> Validated </label>
      </div>
    </div>

    <div *ngIf="vinDecodeErrorMessage || vinDecodeAdditionalError || vinDecodeSuggestedVin" class="form__alert form__alert--warning">
      <i class="pi pi-exclamation-triangle"></i>
      <div>
        <p *ngIf="vinDecodeErrorMessage"><strong>Error:</strong> {{ vinDecodeErrorMessage | titlecase }}</p>
        <p *ngIf="vinDecodeAdditionalError"><strong>Additional Error:</strong> {{ vinDecodeAdditionalError | titlecase }}</p>
        <p *ngIf="vinDecodeSuggestedVin"><strong>Suggested VIN:</strong> {{ vinDecodeSuggestedVin }}</p>
      </div>
    </div>

    <div *ngIf="isVinDecodeFailed" class="form__alert form__alert--warning">
      <p class="form__alert-title">
        <strong>VIN Validation Failed.</strong> You Can Either:
      </p>
      <ul class="form__alert-list">
        <li>Try A Different VIN By Clicking The "Validate" Button Again</li>
        <li>Enter The Vehicle Information Manually Below</li>
      </ul>
    </div>
    <div class="form-row">
      <div class="form-control-container">
        <label for="msrp" class="form-label"> MSRP/NADA </label>
        <input
          id="msrp"
          type="text"
          class="form-control"
          formControlName="msrp"
          numbersOnly
        />
        <ng-container
          *ngTemplateOutlet="formErrors; context: { control: 'msrp' }"
        ></ng-container>
      </div>
    </div>
    
    <!-- Manual Input Toggle -->
    <app-input-field
      [form]="vehicleForm"
      [type]="InputFieldType.Switch"
      label="Manual Input Mode"
      controlName="manual_input_switch"
    ></app-input-field>
    
    <!-- Make / Model / Year - Conditional Rendering -->
    <div class="form-row">
      <ng-container *ngIf="vehicleForm.get('manual_input_switch')?.value; else dropdownMode">
        <!-- Manual Text Inputs -->
        <app-input-field
          [form]="vehicleForm"
          label="Make"
          controlName="make_text"
          placeholder="Enter Make"
        ></app-input-field>
        <app-input-field
          [form]="vehicleForm"
          label="Model"
          controlName="model_text"
          placeholder="Enter Model"
        ></app-input-field>
        <app-input-field
          [form]="vehicleForm"
          label="Year"
          controlName="year_text"
          mask="0000"
          placeholder="Enter Year (4 digits)"
        ></app-input-field>
      </ng-container>
      
      <ng-template #dropdownMode>
        <!-- Dropdown Mode -->
        <div class="form-control-container">
          <label class="form-label required">
            Make
            <span *ngIf="!vehicleForm.get('type')?.value" class="secondary-label">
              (Choose a vehicle type to filter/select a brand.)
            </span>
            <i *ngIf="isBrandsLoading" class="fa-spin fas fa-spinner ms-2"></i>
          </label>
          <p-dropdown
            (onChange)="handleBrandSelect($event)"
            [options]="brandOptions"
            optionLabel="name"
            [filter]="true"
            filterBy="name"
            [resetFilterOnHide]="true"
            placeholder="Select"
            class="rounded-3"
            formControlName="make"
            optionDisabled="disabled"
          ></p-dropdown>

          <ng-container
            *ngTemplateOutlet="formErrors; context: { control: 'make' }"
          ></ng-container>
        </div>
        <div class="form-control-container">
          <label class="form-label required">
            Model
            <span *ngIf="!vehicleForm.get('make')?.value" class="secondary-label">
              (Choose a make to filter/select a model.)
            </span>
            <i *ngIf="isModelsLoading" class="fa-spin fas fa-spinner ms-2"></i>
          </label>
          <p-dropdown
            [options]="modelsOptions"
            optionLabel="name"
            (onChange)="handleModelSelect($event)"
            placeholder="Select Model"
            class="rounded-3"
            formControlName="model"
            optionDisabled="disabled"
          ></p-dropdown>

          <ng-container
            *ngTemplateOutlet="formErrors; context: { control: 'model' }"
          ></ng-container>
        </div>
        <div class="form-control-container">
          <label class="form-label required">
            Year
            <span
              *ngIf="!vehicleForm.get('model')?.value"
              class="secondary-label"
            >
              (Choose a model to filter/select a year.)
            </span>
            <i *ngIf="isYearsLoading" class="fa-spin fas fa-spinner ms-2"></i>
          </label>
          <p-dropdown
            [options]="yearsOptions"
            optionLabel="value"
            placeholder="Select Year"
            class="rounded-3"
            formControlName="year"
            optionDisabled="disabled"
            optionValue="value"
          ></p-dropdown>

          <ng-container
            *ngTemplateOutlet="formErrors; context: { control: 'year' }"
          ></ng-container>
        </div>
      </ng-template>
    </div>
    
    <!-- Fuel Type and other fields -->
    <div class="form-row">
      <app-input-field
        [form]="vehicleForm"
        label="Fuel Type"
        controlName="fuel_type"
        placeholder="Input Fuel Type"
      ></app-input-field>
      <app-input-field
        [form]="vehicleForm"
        controlName="trim_id"
        label="Trim"
        placeholder="Enter Vehicle Trim"
      ></app-input-field>
      <app-input-field
        [form]="vehicleForm"
        controlName="drive_type"
        label="Drive Type"
        placeholder="Enter Vehicle Drive Type"
      ></app-input-field>
      <app-input-field
        [type]="InputFieldType.Number"
        [form]="vehicleForm"
        controlName="cylinder"
        label="Cylinder"
        placeholder="Enter Vehicle Cylinders Number"
      ></app-input-field>
    </div>
    <div class="form-row">
      <app-input-field
        [type]="InputFieldType.Number"
        [form]="vehicleForm"
        controlName="tonnage"
        label="Tonnage"
        placeholder="Enter Tonnage"
      ></app-input-field>
      <app-input-field
        [type]="InputFieldType.Number"
        [form]="vehicleForm"
        controlName="gross_vehicle_weight_rating"
        label="Gross Vehicle Weight Rating"
        placeholder="Enter GVWR"
      ></app-input-field>
      <app-input-field
        [form]="vehicleForm"
        controlName="engine_aspiration"
        label="Engine Aspiration"
        placeholder="Enter Engine Aspiration"
      ></app-input-field>
      <app-input-field
        [form]="vehicleForm"
        controlName="engine_size"
        label="Engine Size (CC)"
        placeholder="Enter Engine Size"
      ></app-input-field>
    </div>
    <div class="form-group">
      <label for="description" class="form-label">Description </label>
      <textarea
        id="description"
        formControlName="description"
        class="form-control"
      ></textarea>
      <ng-container
        *ngTemplateOutlet="formErrors; context: { control: 'description' }"
      ></ng-container>
    </div>
    <app-input-field
      [form]="vehicleForm"
      [type]="InputFieldType.Switch"
      class="is-turbo-switch"
      label="Is Turbo"
      controlName="is_turbo"
    ></app-input-field>
    <app-custom-field-form
      #customFieldComponent
      [isRequired]="true"
      [form]="vehicleForm"
      [module]="'vehicle'"
    >
    </app-custom-field-form>
    <div
      class="action-buttons"
      [ngClass]="{ 'p-dialog-footer p-dialog-footer__dynamic': isModalFooter }"
    >
      <button class="cancel-btn" (click)="handleCreationCancel()">
        Cancel
      </button>
      <button class="custom-btn" (click)="handleSubmit()">
        {{ !!editedVehicleId ? "Update" : "Create" }}
      </button>
    </div>
  </div>
</section>
<app-ngx-loader [loading]="isLoading"></app-ngx-loader>
<ng-template #formErrors let-control="control">
  <app-form-errors
    [color]="'danger'"
    [form]="vehicleForm"
    [control]="vehicleForm.get(control)"
  >
  </app-form-errors>
</ng-template>
